const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');
const { removeNullValues } = require('@/functions/functions');

class PayyoCreateRefundRequestRecord extends AbstractPayyoRequestRecord {
    constructor(paymentData) {
        if (!paymentData) {
            throw new Error('paymentData object is required');
        }

        if (!paymentData.paymentId || !paymentData.paymentId.startsWith('py_')) {
            throw new Error('A valid paymentId is required');
        }

        if (!paymentData.amount) {
            throw new Error('amount is required');
        }

        super(
            'POST',
            'payments/' + paymentData.paymentId + '/refund',
        );

        this.data = removeNullValues(paymentData, true);
        delete this.data.paymentId;
    }
}

module.exports = PayyoCreateRefundRequestRecord;
